import { render, staticRenderFns } from "./WebhooksTable.vue?vue&type=template&id=0a5e56a0&"
import script from "./WebhooksTable.vue?vue&type=script&lang=js&"
export * from "./WebhooksTable.vue?vue&type=script&lang=js&"
import style0 from "./WebhooksTable.vue?vue&type=style&index=0&id=0a5e56a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports